// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BasePhotoUploader_wrapper__39iUV","image":"BasePhotoUploader_image__l_bej","button":"BasePhotoUploader_button__1MB4K","footer":"BasePhotoUploader_footer__1xwDB"};